import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12d09828"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "area-picker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cascader = _resolveComponent("Cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Cascader, {
      value: _ctx.regionValues,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.regionValues) = $event)),
      options: _ctx.areaOpts,
      fieldNames: { label: 'name', value: 'id' },
      onChange: _ctx.handleChange,
      "change-on-select": "",
      allowClear: false,
      placeholder: "请选择区域",
      dropdownClassName: "area-cascader-dropdown"
    }, null, 8, ["value", "options", "onChange"])
  ]))
}